import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, CalendarDays } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María G.',
    role: 'Enfermera en Houston, TX',
    img: 'https://i.pravatar.cc/150?img=47',
    quote: "Trabajo turnos de 12 horas. Antes, bajarme del auto al llegar a casa me hacía llorar. Con el protocolo de 2 minutos, la 'aguja' en mi talón desapareció en la primera semana. Es un milagro para mí.",
    result: 'Alivio en 4 días'
  }, {
    name: 'Carmen R.',
    role: 'Personal de Limpieza en Miami, FL',
    img: 'https://i.pravatar.cc/150?img=32',
    quote: 'Había gastado más de $200 en zapatos y plantillas especiales. Nada funcionaba como este manual. Hacer los ejercicios en la cama antes de pisar cambió todo. Ya no cojeo en las mañanas.',
    result: 'Caminó sin dolor en 5 días'
  }, {
    name: 'Lucía M.',
    role: 'Maestra en Phoenix, AZ',
    img: 'https://i.pravatar.cc/150?img=5',
    quote: 'Estar de pie frente a los niños era una tortura. La técnica del frío por la tarde me devuelve la vida a los pies. Lo recomiendo a todas mis compañeras maestras.',
    result: 'Aguanta jornada completa'
  }, {
    name: 'Patricia S.',
    role: 'Retail Manager en Los Angeles, CA',
    img: 'https://i.pravatar.cc/150?img=44',
    quote: 'Pensé que tendría que renunciar a mi trabajo por el dolor. El plan de 7 días es súper claro y fácil de seguir. Vale cada centavo y mucho más.',
    result: 'Alivio desde el día 1'
  }];
  return <section className="py-24 bg-brand-50 overflow-hidden" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="text-center mb-16" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-191">
            Mujeres reales. Resultados reales.
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-192">
            Únete a las miles de trabajadoras que han recuperado sus mañanas y
            su energía.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-20" data-id="element-193">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-soft relative" data-id="element-194">
              <Quote className="absolute top-6 right-8 w-12 h-12 text-brand-100" data-id="element-195" />
              <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-196">
                <img src={t.img} alt={t.name} className="w-16 h-16 rounded-full object-cover border-2 border-brand-100" data-id="element-197" />
                <div data-id="element-198">
                  <h4 className="font-bold text-slate-900 text-lg" data-id="element-199">{t.name}</h4>
                  <p className="text-sm text-slate-500" data-id="element-200">{t.role}</p>
                  <div className="flex text-yellow-400 mt-1" data-id="element-201">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-202" />)}
                  </div>
                </div>
              </div>
              <p className="text-slate-700 italic mb-6 relative z-10 leading-relaxed" data-id="element-203">
                "{t.quote}"
              </p>
              <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 px-3 py-1.5 rounded-full text-sm font-medium" data-id="element-204">
                <CalendarDays className="w-4 h-4" data-id="element-205" />
                {t.result}
              </div>
            </motion.div>)}
        </div>

        {/* Timeline Expectation */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft max-w-4xl mx-auto border border-brand-100" data-id="element-206">
          <h3 className="text-2xl font-display font-bold text-center text-slate-900 mb-10" data-id="element-207">
            ¿Qué puedes esperar?
          </h3>
          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-brand-200 before:via-brand-400 before:to-brand-600" data-id="element-208">
            {[{
            day: 'Día 1',
            title: 'El primer alivio',
            desc: "Notarás que la 'aguja' en tu talón ya no es tan afilada al despertar."
          }, {
            day: 'Día 4',
            title: 'Movilidad recuperada',
            desc: 'Podrás caminar hacia la cocina por la mañana sin apoyarte en los muebles.'
          }, {
            day: 'Día 7',
            title: 'Jornada completa',
            desc: 'Tus pies se sentirán lo suficientemente fuertes para aguantar tu turno laboral sin terminar en agonía.'
          }].map((item, idx) => <div key={idx} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-209">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-brand-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10 font-bold text-sm" data-id="element-210">
                  {idx + 1}
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-slate-50 p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-211">
                  <div className="flex items-center gap-3 mb-2" data-id="element-212">
                    <span className="bg-brand-100 text-brand-700 text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-213">
                      {item.day}
                    </span>
                    <h4 className="font-bold text-slate-900" data-id="element-214">{item.title}</h4>
                  </div>
                  <p className="text-slate-600 text-sm" data-id="element-215">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}